import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import BreakpointProvider from '@cotyorg/ccx-utils/js/components/BreakpointProvider';
import configureStore from './state/store';
import App from './App';
import breakpoints from '../styles/_breakpoints.scss';

// TODO: [2] we should split this up to get benefit of component splitting better
import '../styles/main.scss';

const preloadedState = window.__PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle

// Allow the passed state to be garbage-collected
// https://redux.js.org/recipes/server-rendering#the-client-side
delete window.__PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle

const store = configureStore(preloadedState);

// TODO: [2] re-investigate hot reloading/developer experience
// const AppContainer = ({ children }) => {
//   if (module.hot) {
//     const AppContainer = require('react-hot-loader').AppContainer; // eslint-disable-line
//     return <AppContainer>{React.Children.only(children)}</AppContainer>;
//   }
//   return React.Children.only(children);
// };

const supportsHistory = 'pushState' in window.history;

const renderApp = () => {
  const MOUNT_POINT = document.getElementById('app');

  hydrate(
    <Provider store={store}>
      <BreakpointProvider breakpoints={breakpoints}>
        <BrowserRouter forceRefresh={!supportsHistory}>
          <App />
        </BrowserRouter>
      </BreakpointProvider>
    </Provider>,
    MOUNT_POINT
  );
};

renderApp();

// TODO: [2] re-investigate hot reloading/developer experience
// if (module.hot && __DEV__) { // eslint-disable-line no-undef
//   module.hot.accept('./App', () => {
//     const AppHot = require('./App').default; // eslint-disable-line global-require
//     renderApp(AppHot);
//   });
// }
